export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const LANDING = '/';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const PASSWORD_FORGET = '/pw-forget';
export const TERMS = '/termos';
export const GUEST = '/guest/s/azjs3kjx/';



// WEBPACK FOOTER //
// ./src/constants/routes.js